if (!customElements.get('play-on-click')) {
  class PlayOnClick extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', () => this.play());
      this.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          this.play();
        }
      });
    }

    play() {
      if (this.dataset.playing === 'true') return;
      this.dataset.playing = 'true';

      const embed = this.dataset.embed;
      if (embed) {
        const iframe = document.createElement('iframe');
        iframe.src = embed;
        iframe.className = 'absolute inset-0 w-full h-full';
        iframe.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
        iframe.allowFullscreen = true;
        iframe.title = this.getAttribute('aria-label') || 'Video';
        this.append(iframe);
      }

      const video = this.querySelector('video');
      if (video) {
        video.controls = true;
        video.muted = false;
        video.play().catch(() => {});
      }

      this.querySelector('[data-poster]')?.remove();
      this.querySelector('[data-play-button]')?.remove();
      this.removeAttribute('role');
      this.removeAttribute('tabindex');
    }
  }

  customElements.define('play-on-click', PlayOnClick);
}
